import { useContext } from 'react'

import { Form } from 'components/Form'
import Loading from 'components/Loading'
import { AddEditDomainContext } from 'features/inventory/domain/contexts/AddEditDomainContext'
import { useUpdateDomainMultiAnchor } from 'features/inventory/domain/forms/RichPlacementsForm/hooks/useUpdateDomainMultiAnchor'
import { Schema, schema, schemaDefault } from './schema'
import { MultiAnchorSection } from './Section'

export const MultiAnchorForm = (): JSX.Element => {
  const {
    domain,
    formId,
    loading: isFetching,
    setTouched,
    setValid,
  } = useContext(AddEditDomainContext)
  const { errors, isPending: isUpdating, update } = useUpdateDomainMultiAnchor()

  if (!domain) {
    return <Loading />
  }

  return (
    <Form<Schema>
      externalErrors={errors}
      id={formId}
      loading={isFetching || isUpdating}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={schema}
      schemaDefaults={schemaDefault(domain)}
    >
      {() => <MultiAnchorSection />}
    </Form>
  )
}
